import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useAxiosInstance } from "../../../services/Interceptor";
import { getMeasurements } from "../../../services/AthleteService";
import { getMeasurementsResultsByEvent } from "../../../services/CombineService";
import ProgressBar from "../athlete-progress-bar";
import LoadingSpinner from "../../LoadingSpinner";
import AthleteMeasurementsListAthletic from "./athlete-measurements-list-athletic";
import AthleteMeasurementsListPosition from "./athlete-measurements-list-position";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import AthleteMeasurementVideoViewer from "./athlete_measurement_videoviewer";
import ReactPlayer from "react-player";
import { usePublicSession } from "../../../services/context/PublicSessionContext";

export default function AthleteMeasurements({ profile = {} }) {
  const apiInstance = useAxiosInstance();
  const [loading, setLoading] = useState(true);
  const [listInfo, setListInfo] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const r_athlete = useSelector((state) => state.athletes);
  const {
    buttons: {
      measurements: { tab, athleteTabSelected, positionTabSelected },
    },
  } = r_athlete;
  const { isPublicView } = usePublicSession() ?? {};
  const hasSubscription = useSelector((state) => state.user.hasSubscription);
  const hasSubscriptionAccess = isPublicView || hasSubscription;

  const closeModal = () => setIsOpen(false);

  const getData = async () => {
    try {
      let results = [];
      if (r_athlete.config.searchEvent && r_athlete.config.eventId) {
        results = await getMeasurementsResultsByEvent(
          apiInstance,
          r_athlete.config.eventId,
          profile.id,
        );
      } else {
        results = await getMeasurements(apiInstance, profile.id);
      }
      if (results.status === 200) {
        setListInfo(results.data);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const result = async () => {
      await getData();
    };
    result();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.id, r_athlete.config.eventId]);

  if (loading)
    return (
      <div className="my-10">
        <LoadingSpinner />
      </div>
    );

  return (
    listInfo &&
    !r_athlete.loading && (
      <>
        <div className="mt-1 px-4 -m-4 overflow-y-auto relative">
          {!hasSubscriptionAccess && (
            <div className="absolute top-2 right-4 z-10 bg-hide w-[35%] lg:w-[50%] rounded-r-md -mr-4 h-[95%]">
              <div className="text-center h-full px-6 py-44 lg:py-40">
                <FontAwesomeIcon icon={faLock} className="h-6 pt-1" />
                <p className="text-sm">
                  Unlock premium features and exclusive <br />
                  content with a full subscription.
                </p>
              </div>
            </div>
          )}

          {tab && athleteTabSelected && (
            <div className="mt-2">
              <div className="mb-2 bg-blue-50 rounded-lg border border-blue-200 px-3 py-2 items-center">
                <div className="font-medium ">
                  Trackit Measurement Score
                  <div className="w-full ">
                    {hasSubscriptionAccess && (
                      <ProgressBar
                        score={
                          listInfo.measurementScores?.measurementScoreData
                            ? Math.round(
                                listInfo.measurementScores.measurementScoreData,
                              )
                            : 0
                        }
                      />
                    )}
                  </div>
                  <div className="w-full ">
                    {hasSubscriptionAccess && (
                      <>
                        <div className="text-blue-600 text-sm">
                          <AthleteMeasurementVideoViewer
                            title="Overhead Squat"
                            videoUrls={
                              listInfo?.measurementVideosByType?.Full?.map(
                                (v) => v.filePath,
                              ) || []
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <AthleteMeasurementsListAthletic result={listInfo} />
            </div>
          )}
          {tab && positionTabSelected && (
            <div className="mt-2">
              <div className="mb-2 bg-blue-50 rounded-lg border border-blue-200 px-3 py-2 items-center">
                <div className="font-medium ">
                  Position Measurement Score
                  <div className="w-full ">
                    {hasSubscriptionAccess && (
                      <div className="w-full ">
                        <ProgressBar
                          score={
                            listInfo.measurementScores?.positionMeasurementScore
                              ? Math.round(
                                  listInfo.measurementScores
                                    .positionMeasurementScore,
                                )
                              : 0
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="w-full ">
                    {hasSubscriptionAccess && (
                      <>
                        <div className="text-blue-600 text-sm">
                          <AthleteMeasurementVideoViewer
                            title="Overhead Squat"
                            videoUrls={
                              listInfo?.measurementVideosByType?.Full?.map(
                                (v) => v.filePath,
                              ) || []
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <AthleteMeasurementsListPosition result={listInfo} />
            </div>
          )}
        </div>

        {/* Video Modal Pop up */}
        {isOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="absolute inset-0 bg-gray-900 opacity-50"></div>
            <div className="bg-white rounded-lg shadow-lg z-50 max-w-screen-lg w-full p-2 m-4">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Measurement Score</h2>
                <button
                  className="text-gray-500 hover:text-gray-700"
                  onClick={closeModal}
                >
                  ✕
                </button>
              </div>
              <div className="relative p-0 w-full">
                <div className="w-[250px] h-[200px] bg-black">
                  <ReactPlayer
                    controls
                    light
                    src="https://ik.imagekit.io/ikmedia/example_video.mp4"
                    playsinline
                    width="100%"
                    height="300px"
                    onError={(e) => console.error("ReactPlayer error", e)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  );
}
